import { useState } from 'react';
import { useField } from 'formik';
import { useDispatch } from 'react-redux';

import { TThunkDispatch } from '../../../../../types/redux';
import { IAttachedDocument } from '../../../../../types/requestFormValue';
import { uploadFile } from '../../../../../actions/file';
import { useFileUploadTracking } from '../../../utils';

export interface IUseMultipleFilesUploadFieldProps {
  name: string;
}

export const useSingleFilesUploadField = (props: IUseMultipleFilesUploadFieldProps) => {
  const { trackSelectDocuments } = useFileUploadTracking();
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch<TThunkDispatch>();
  /** После загрузки файлов следует перерендерить инпут ввода, для сброса значений инпута **/
  const [fileInputKey, setFileInputKey] = useState(Date.now());

  const [field, meta, helpers] = useField<IAttachedDocument | null>({
    name: props.name,
  });

  const handleFileSelect = async (files: FileList) => {
    const file = files.item(0);
    /* istanbul ignore next */
    if (field.value || !file || isLoading) {
      return;
    }

    trackSelectDocuments();

    helpers.setTouched(true);
    helpers.setError(undefined);
    setIsLoading(true);

    try {
      const document = await dispatch(uploadFile({ file }));
      helpers.setValue(document, true);
    } catch (error) {
      /* oxlint-disable-next-line typescript/no-explicit-any */
      helpers.setError(`Не удалось загрузить файл` as any);
    } finally {
      setIsLoading(false);
      setFileInputKey(Date.now());
    }
  };

  const handleFileRemove = async () => {
    /* istanbul ignore next */
    if (!field.value) {
      return;
    }

    helpers.setValue(null, true);
    helpers.setTouched(true);
  };

  return {
    isLoading,
    handleFileSelect,
    handleFileRemove,
    fileInputKey,
    error: meta.error,
    touched: meta.touched,
    value: field.value,
    name: field.name,
  };
};
